<template>
  <div class="CompetitionHeader-styles-competition-header CompetitionHeader-styles-include-last-column-spacing">
    <div class="CompetitionTitle-styles-competition-title-wrapper">
      <div class="CompetitionTitle-styles-competition-title">
        <span :class="(isCompetitionFavorite) ? 'Favorite-styles-selected' : ''" class="Favorite-styles-favorites" @click.prevent="addCompetitionFav(competition)"></span>
        <span style="width: 20px; margin-right: 5px; margin-top: 5px;" class="flag-ico" :class="'flag-'+competition.region.n.toLowerCase()" ></span>
        <span class="CompetitionTitle-styles-title CompetitionTitle-styles-caption">
          {{ competition.region.name }} - {{ competition.name }}
        </span>
        <a href="javascript:;" class="CompetitionStatsButton-styles-show-statistics" target="_blank" rel="nofollow"></a>
      </div>
    </div>

    <template v-if="list == 1">
      <template v-if="competition.sport.sportId == 1 || competition.sport.sportId == 77">
        <marketLabel :onLive="onLive" :id="1" />
        <marketLabel :onLive="onLive" :id="2" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="3" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="4" v-if="!$route.params.event" />
      </template>
      <template v-if="competition.sport.sportId == 2">
        <marketLabel :onLive="onLive" :id="5" />
        <marketLabel :onLive="onLive" :id="6" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="7" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="8" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 3">
        <marketLabel :onLive="onLive" :id="9" />
        <marketLabel :onLive="onLive" :id="10" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="11" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="12" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 4">
        <marketLabel :onLive="onLive" :id="13" />
        <marketLabel :onLive="onLive" :id="14" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="15" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="16" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 9">
        <marketLabel :onLive="onLive" :id="17" />
        <marketLabel :onLive="onLive" :id="18" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="19" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="20" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 19">
        <marketLabel :onLive="onLive" :id="21" />
        <marketLabel :onLive="onLive" :id="22" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="23" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="24" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 24">
        <marketLabel :onLive="onLive" :id="25" />
        <marketLabel :onLive="onLive" :id="26" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="27" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="28" v-if="!$route.params.event" />
      </template>

    </template>

    <template v-if="list == 2">
      <template v-if="competition.sport.sportId == 1 || competition.sport.sportId == 77">
        <marketLabel :onLive="onLive" :id="1" />
        <marketLabel :onLive="onLive" :id="2" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="3" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 2">
        <marketLabel :onLive="onLive" :id="4" />
        <marketLabel :onLive="onLive" :id="5" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="6" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 3">
        <marketLabel :onLive="onLive" :id="7" />
        <marketLabel :onLive="onLive" :id="8" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="9" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 4">
        <marketLabel :onLive="onLive" :id="10" />
        <marketLabel :onLive="onLive" :id="11" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="12" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 9">
        <marketLabel :onLive="onLive" :id="13" />
        <marketLabel :onLive="onLive" :id="14" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="15" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 19">
        <marketLabel :onLive="onLive" :id="16" />
        <marketLabel :onLive="onLive" :id="17" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="18" v-if="!$route.params.event" />
      </template>

      <template v-if="competition.sport.sportId == 24">
        <marketLabel :onLive="onLive" :id="19" />
        <marketLabel :onLive="onLive" :id="20" v-if="!$route.params.event" />
        <marketLabel :onLive="onLive" :id="21" v-if="!$route.params.event" />
      </template>
    </template>

  </div>
</template>

<script>

import favorite from '@/mixins/favorite'
import marketLabel from "./marketLabel";
export default {
  name: 'competitionRow',
  components: {marketLabel},
  mixins: [favorite],
  props: ['competition', 'extendedMarkets', 'list', 'onLive'],
  data () {
    return {
      t: this.$root.t,
      outcomes: []
    }
  },

  mounted() {
    this.checkIsCompetitionFavorite(this.competition);
    this.$bus.$on('marketSelectionOutcomes', (payload) => {

      th.outcomes = payload;

    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/CompetitionRow.vue